const siderBar = {
  profile: "主頁",
  history: "歷史",
  setting: "設定",
  promotion: "優惠",
};

export default siderBar;